module.exports = __webpack_public_path__ + "static/media/east tower shot 10.4273cd69.webp";